export default __webpack_public_path__ + "media/images/main/header-203496b2621e3c1bf2363453c4215720.png";